import { inputBorderColor } from '../../../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	dropdownContentInnerOverrides: {
		borderColor: inputBorderColor,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		borderTopRightRadius: 0,
		maxHeight: '550px !important',
	},
	donationTypeOptions: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	radioButtonRow: {
		display: 'flex',
		gap: 8,
	},
	firstDonationCheckbox: {
		marginLeft: 24,
	},
});
